import i18n from 'helper/i18n';
import { filterForTag } from './utils';

import { ContentTypePoolRecipeDtoType } from 'types/services/magnolia/dtos/ContentTypePoolRecipeDto';
import { NutritionPhilosophyType } from '../../../../../types/DietaryHabits';

// TODO: Refactor to ENUM

export const FILTER_ID = 'RECIPE_DIET_FORM' as const;

export const RECIPE_TAG_IDS = {
	NUTRITION_PHILOSOPHY_VEGETARIAN: 'root.vegetarian.',
	NUTRITION_PHILOSOPHY_VEGAN: 'root.vegan.',
} as const;

export const TAG_ID = 'nutrition-philosophy';

type FilterFactoryFunction = (item: ContentTypePoolRecipeDtoType) => boolean;

export const FILTER_FACTORY: { [key in NutritionPhilosophyType]: FilterFactoryFunction } = {
	VEGETARIAN: (item: ContentTypePoolRecipeDtoType) =>
		filterForTag(item, TAG_ID, RECIPE_TAG_IDS.NUTRITION_PHILOSOPHY_VEGETARIAN) ||
		filterForTag(item, TAG_ID, RECIPE_TAG_IDS.NUTRITION_PHILOSOPHY_VEGAN),
	VEGAN: (item: ContentTypePoolRecipeDtoType) =>
		filterForTag(item, TAG_ID, RECIPE_TAG_IDS.NUTRITION_PHILOSOPHY_VEGAN),
	UNKNOWN: (item: ContentTypePoolRecipeDtoType) => {
		return true;
	},
	MEAT_FISH: (item: ContentTypePoolRecipeDtoType) => {
		return true;
	},
};

export const FILTER = {
	VEGETARIAN: 'VEGETARIAN',
	VEGAN: 'VEGAN',
} as const;

export const FILTER_LABELS: { [key: string]: React.ReactNode } = {
	VEGETARIAN: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.VEGETARIAN}`),
	VEGAN: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.VEGAN}`),
};

export function filterForDietForm(filter: (keyof typeof FILTER)[]): (item: ContentTypePoolRecipeDtoType) => boolean {
	return (item: ContentTypePoolRecipeDtoType) => {
		return filter.every((currentFilter) => {
			return FILTER_FACTORY[currentFilter](item);
		});
	};
}

export default filterForDietForm;
